import React, { useRef } from 'react'
import classnames from 'classnames'
import { Button, IconButton, BUTTON_THEME, BUTTON_SIZE } from '@st-operations/uikit/src/v2/index.js'

import useFiltersCRUD from '../useFiltersCRUD'
import FilterEditForm from '../filter-edit-form/index.jsx'

import './styles.scss'
import Popup from '_components/popup/index.jsx'

const ManageFilter = ({ className, id }) => {
  const popupRef = useRef()

  const {
    handleSaveChanges,
    handleEditFilter,
    selectedTabIndex,
    handleSelectFilter,
    isLoading,
    filters,
    handleRemoveFilter,
  } = useFiltersCRUD({
    onSave: () => {
      popupRef.current?.close()
    },
    saveOnDelete: true,
  })

  const handleEditButtonClick = () => {
    handleSelectFilter({ currentTarget: { value: id } })
    popupRef.current?.open()
  }

  const handleDeleteButtonClick = () => {
    handleRemoveFilter(id)
  }

  return (
    <div className={classnames('manage-filter', className)}>
      <div className="manage-filter__buttons">
        <div ref={popupRef.current?.setTriggerRef} style={{ width: 24, height: 24 }}>
          <IconButton
            text="Edit"
            className="manage-filter__button"
            onClick={handleEditButtonClick}
            iconProps={{ icon: 'edit', type: 'fill', width: 24, height: 24 }}
          />
        </div>
        <IconButton
          text="Delete"
          className="manage-filter__button"
          onClick={handleDeleteButtonClick}
          iconProps={{ icon: 'trashcan', type: 'fill', width: 24, height: 24 }}
        />
      </div>
      <Popup ref={popupRef}>
        <div className="manage-filter__dialog">
          <FilterEditForm
            key={selectedTabIndex}
            className="manage-filter__edit-form"
            id={selectedTabIndex}
            attribute={filters?.[selectedTabIndex]?.key}
            operator={filters?.[selectedTabIndex]?.operator}
            value={filters?.[selectedTabIndex]?.value}
            hasHeader={filters?.[selectedTabIndex]?.hasHeader}
            onEdit={handleEditFilter}
          />
          <footer>
            <Button
              className="manage-filter__footer-button"
              onClick={() => popupRef.current?.close()}
              theme={BUTTON_THEME.GHOST}
              size={BUTTON_SIZE.SMALL}
            >
              Cancel
            </Button>
            <Button
              isLoading={isLoading}
              className="manage-filter__footer-button"
              onClick={handleSaveChanges}
              size={BUTTON_SIZE.SMALL}
            >
              Save
            </Button>
          </footer>
        </div>
      </Popup>
    </div>
  )
}

export default ManageFilter
